import { useState, useMemo, useCallback } from 'react'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { useEmojiNameToDisplayMap } from 'hooks/useEmojiState'
import { IndexWidgetsType } from '../../../types'
import useSearchFilterComposingStrategy from './useSearchFilterComposingStrategy'
import useWidgetSettingComposingStrategy from './useWidgetSettingComposingStrategy'
import { convertToInsightContentSetting, addSelectionFilterToWidgetSetting } from '../utils'

const useSelectedInsights = (widgetSetting: IndexWidgetsType) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInsights, setSelectedInsights] = useState<InsightData[]>([])
  const emojiNameToDisplayMap = useEmojiNameToDisplayMap()

  const searchFilterComposingStrategy = useSearchFilterComposingStrategy(widgetSetting.viewOption!)
  const widgetSettingComposingStrategy = useWidgetSettingComposingStrategy(
    widgetSetting.viewOption!
  )

  const detailSetting = useMemo(
    () =>
      convertToInsightContentSetting(
        widgetSetting,
        searchFilterComposingStrategy,
        {
          insights: selectedInsights
        },
        emojiNameToDisplayMap
      ),
    [searchFilterComposingStrategy, widgetSetting, selectedInsights, emojiNameToDisplayMap]
  )

  const widgetSettingWithSelection = useMemo(
    () =>
      addSelectionFilterToWidgetSetting(widgetSetting, widgetSettingComposingStrategy, {
        insights: selectedInsights
      }),
    [widgetSettingComposingStrategy, widgetSetting, selectedInsights]
  )

  const onClick = useCallback(
    (insightData: InsightData) => {
      setIsModalOpen(true)
      setSelectedInsights([insightData])
    },
    [setIsModalOpen, setSelectedInsights]
  )

  const onClose = useCallback(() => {
    setIsModalOpen(false)
    setSelectedInsights([])
  }, [setIsModalOpen, setSelectedInsights])

  return {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  }
}

export default useSelectedInsights
